var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTopbarInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 16.1409H19.42L14.54 21.0209C14.15 21.4109 14.15 22.0509 14.54 22.4409C14.93 22.8309 15.56 22.8309 15.95 22.4409L22.54 15.8509C22.93 15.4609 22.93 14.8309 22.54 14.4409L15.96 7.84089C15.7732 7.65363 15.5195 7.5484 15.255 7.5484C14.9905 7.5484 14.7368 7.65363 14.55 7.84089C14.16 8.23089 14.16 8.86089 14.55 9.25089L19.42 14.1409H8.25C7.7 14.1409 7.25 14.5909 7.25 15.1409C7.25 15.6909 7.7 16.1409 8.25 16.1409Z",
    fill: "#C3CAD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopbarInput);
export default __webpack_public_path__ + "static/media/arrow_topbar_input.9ea203b5b8c07ab97fbf350de53f18d2.svg";
export { ForwardRef as ReactComponent };